import Ajax from '../common/ajax'

export default {
  model: 'data',
  getPage (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/enrollSummary`, queryParam)
  },
  getBatchPage (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/examSummary`, queryParam)
  },
  getSpecialtyPage (queryParam) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/specialtySummary`, queryParam)
  }
}
